export default __webpack_public_path__ + "static/media/Cheese.40c20dbd.jpg";